'use strict';

var React = require('react');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n.default = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);

// tmp/MapView.tsx
var SvgMapView = (props) => /* @__PURE__ */ React__namespace.createElement("svg", { viewBox: "0 0 24 24", role: "img", "aria-hidden": "true", ...props }, /* @__PURE__ */ React__namespace.createElement("path", { d: "M1.646 1.339A.75.75 0 0 0 1.25 2v16c0 .284.16.544.415.67l6 3a.75.75 0 0 0 .63.02l6.657-2.854 6.676 3.815A.75.75 0 0 0 22.75 22V6a.75.75 0 0 0-.455-.69l-7-3a.75.75 0 0 0-.59 0L8.078 5.15 2.416 1.377a.75.75 0 0 0-.77-.037ZM8.75 6.495l5.5-2.358v13.369l-5.5 2.357V6.495Zm-1.5 13.291-4.5-2.25V3.402l4.5 3v13.386Zm8.5-2.221V4.137l5.5 2.358v14.213l-5.5-3.143Z" }));
var MapView_default = SvgMapView;

module.exports = MapView_default;
